export class BoSession {
    
    id: number;
  
    
    userId: number;
  
    created: Date;
  
    lastPing: Date;
  }